import { render, staticRenderFns } from "./MinesGame.vue?vue&type=template&id=210a5b90&scoped=true"
import script from "./MinesGame.vue?vue&type=script&lang=js"
export * from "./MinesGame.vue?vue&type=script&lang=js"
import style0 from "./MinesGame.vue?vue&type=style&index=0&id=210a5b90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210a5b90",
  null
  
)

export default component.exports